var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#0000E3",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2292 17.75V19.25H9.60417V17.9609L13.3073 13.9219C13.7135 13.4635 14.0339 13.0677 14.2682 12.7344C14.5026 12.401 14.6667 12.1016 14.7604 11.8359C14.8594 11.5651 14.9089 11.3021 14.9089 11.0469C14.9089 10.6875 14.8411 10.3724 14.7057 10.1016C14.5755 9.82552 14.3828 9.60938 14.1276 9.45312C13.8724 9.29167 13.5625 9.21094 13.1979 9.21094C12.776 9.21094 12.4219 9.30208 12.1354 9.48438C11.849 9.66667 11.6328 9.91927 11.487 10.2422C11.3411 10.5599 11.2682 10.9245 11.2682 11.3359H9.38542C9.38542 10.6745 9.53646 10.0703 9.83854 9.52344C10.1406 8.97135 10.5781 8.53385 11.151 8.21094C11.724 7.88281 12.4141 7.71875 13.2214 7.71875C13.9818 7.71875 14.6276 7.84635 15.1589 8.10156C15.6901 8.35677 16.0938 8.71875 16.3698 9.1875C16.651 9.65625 16.7917 10.2109 16.7917 10.8516C16.7917 11.2057 16.7344 11.5573 16.6198 11.9062C16.5052 12.2552 16.3411 12.6042 16.1276 12.9531C15.9193 13.2969 15.6719 13.6432 15.3854 13.9922C15.099 14.3359 14.7839 14.6849 14.4401 15.0391L11.9792 17.75H17.2292Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.49b2670b6bb8f76a07814401a711cb05.svg";
export { ForwardRef as ReactComponent };